// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1OtcQ","content":"LayoutSettings_content__3v4QZ"};